var sidenav = {
	wrapperEl: $('.sidenav-navItem'),
	contentEl: $('.sidenav-item-content'),
	socialMediaEl:$('.social-image-fallback'),

	expandCollapse: function(_this) {
		nav.undoOthers.undoSubnav();
		$('.weather-open .weather-extended').slideUp();
		weather.wrapper.removeClass('weather-open');

		if (_this.hasClass('active')) {
			sidenav.contentEl.slideUp();
			sidenav.wrapperEl.removeClass('active');

		 }
		else {
			sidenav.wrapperEl.removeClass('active');
			_this.addClass('active');
			sidenav.contentEl.slideUp();
			_this.find(sidenav.contentEl).slideDown();
		}
	},

	eventListeners: function() {
		sidenav.wrapperEl.click(function(e) {
			if (isTouch || (!isTouch && windowWidth < desktop)) {
				if ($(e.target).closest('.sidenav-opening-hours-table').length) {
					return;
				}
				sidenav.expandCollapse($(this));

				// if there's a hash on the link, close the main nav
				if (e.target.href && e.target.href.indexOf("#") != -1){
					nav.openClose.closeNav.click();
				}
			} else if (!isTouch && windowWidth >= desktop) {
				// if there's a hash on the link, close the main nav
				if (e.target.href && e.target.href.indexOf("#") != -1){
					var targetHash = $(e.target).attr('href').split('#')[1];
					if ($('#' + targetHash).length) {
						e.preventDefault();
						heroNav.scrollToSection($(e.target).attr('href'));
					}
				}
			}
		});


		
	},

	fixOffset: function() {
		var offsetDiff = 20;

		if (windowWidth >= desktop) {
			offsetDiff = 80;
		}
		return offsetDiff;
	},

	init: function() {
		sidenav.eventListeners();
	}
};